import { Language } from './base';

const pdash = () => import('../translations/pdash/en-US.json');
const rdash = () => import('../translations/rdash/en-US.json');
const webActivities = () => import('../translations/web-activities/en-US.json');
const rdashTranslatables = () => import('../translations/rdash-translatables/en-US.json');

export default new Language({
    code: 'en-US',
    locale: 'en',
    localName: 'English',
    englishName: '',
    territory: 'US',
    notLoadedNamespaces: { pdash, rdash, webActivities, rdashTranslatables },
});
